import {Component, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';
import {AssetsService} from '../_services/assets.service';
import {takeUntil} from 'rxjs/operators';
import {AssetModel} from '../_models/asset.model';
import {SoService} from '../../shared/_services/so.service';
import {FuncsService} from '../../shared/_services/funcs.service';

@Component({
  selector: 'app-assets-tree',
  templateUrl: './assets-tree.component.html',
  styleUrls: ['./assets-tree.component.scss']
})

export class AssetsTreeComponent implements OnDestroy {

  isActive = false;
  assets: AssetModel[] = [];

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private assetsService: AssetsService,
    private soService: SoService,
  ) {
    this.getSo();
    this.getAssets();
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }

  // ********************************************************************************************************
  // LOAD DATA
  // ********************************************************************************************************

  private getSo(): void {
    this.soService.onNewSoActive()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (so) => {
          this.isActive = so === 'assets';
        }
      );
  }

  private getAssets(): void {
    this.assetsService.onNewAssets()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (assets) => {
          // take copy so the charts don't reload all the time when changing selections
          this.assets = FuncsService.copy(assets) as AssetModel[];
        }
      );
  }

  // ********************************************************************************************************
  // PROCESS DATA
  // ********************************************************************************************************

  // ********************************************************************************************************
  // UI
  // ********************************************************************************************************

  // EVENT LISTENERS
  onSelect(obj: any, newState: boolean, countryIdx: number): void {
    this.recurseSelect(obj, newState, countryIdx);
    this.assetsService.setAssetsSelected(this.assets[countryIdx]);
    this.assetsService.newAssets(this.assets);
  }

  private recurseSelect(obj: any, newState: boolean, countryIdx: number): void {
    obj.selected = newState;
    for (const key in obj) {
      if (Array.isArray(obj[key]) && key !== 'assetsSelected') {
        for (const cur of obj[key]) {
          this.recurseSelect(cur, newState, countryIdx);
        }
      }
    }
  }

}
